module.exports = __webpack_public_path__ + "static/media/DSA.27921805.png";